<div class="PGNotification m-0 {{getMainClass()}}">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <i class="{{getIconClass()}} fa-fw"></i>
            @if (notification.from != null) {
                <span class="ms-2">{{notification.from}}</span>
            }
            @if (notification.from == null) {
                <span class="ms-2" [innerHTML]="formatContent()"></span>
            }
        </div>
        <div>
            @if (getStatusClass(); as class) {
                <span>
                    <i class="{{class}}"></i>
                </span>
            }
            <small class="text-muted ms-2">{{formatTime()}}</small>
        </div>
    </div>
    @if (notification.from != null) {
        <hr class="my-2"/>
        <div class="PGNotification-Content">
            <div class="PGNotification-Content-Inner">
                <div [innerHTML]="formatContent()"></div>
                <div class="d-flex justify-content-between">
                    <div>
                        @if (notification.has_children) {
                            <button class="btn btn-sm btn-link p-0" (click)="toggleChildNotifications()">
                                <i class="fa-regular fa-chevron-{{areChildNotificationsShown ? 'up' : 'down'}}"></i>
                                <span>{{ 'pg-notification.children' | locTranslate }}</span>
                            </button>
                        }
                    </div>
                    <div>
                        @if (notification.content.link) {
                            <a class="btn btn-sm btn-link p-0" href="{{notification.content.link}}" target="_blank">
                                <span>{{ 'pg-notification.link' | locTranslate }}</span>
                                <i class="fa-regular fa-arrow-up-right-from-square"></i>
                            </a>
                        }
                    </div>
                </div>
            </div>
        </div>
        @if (areChildNotificationsShown) {
            <div class="PGNotification-Children mt-2">
                @if (isLoadingChildren) {
                    <app-pg-loading></app-pg-loading>
                }
                @if (!isLoadingChildren) {
                    <div class="border-start border-primary ps-2 mt-1 mb-2">
                        @for (child of childNotifications; track child) {
                            <div class="my-2">
                                <app-pg-notification [notification]="child"></app-pg-notification>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    }
</div>